(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-todo', {
            parent: 'entity',
            url: '/customer-todo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.dashboard.customerToDo" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/2/dashboard.html',
                    controller: 'CustomerApprovalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('customerToDo');
                    $translatePartialLoader.addPart('customer-registration');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
